import * as React from 'react'
import * as moment from 'moment'
import { Link, Route, Switch, Redirect } from 'react-router-dom'
import ProductInfoPane from '../../../../../containers/products/productdetail/ProductInfo'
import ProductIntegrationPane from '../../../../../containers/products/productdetail/ProductIntegration'
import ProductPricingPane from '../../../../../containers/products/productdetail/ProductPricing'
import { IProviderProductObject } from '../../../../../types'
import UIMessages from '../../../../../utils/ui-messages'
import ProductStepSelector from './ProductStepSelector'
import BackToList from 'src/components/ui/BackToList'
import ButtonBlueWithIcon from 'src/components/ui/ButtonBlueWithIcon'
import Edit from 'src/components/icons/organizations/Edit'

interface IProductDetailPaneProps {
  product: IProviderProductObject
  productId: string
  location: any
  fetchProduct: (productId: string) => void
}

interface IProductStepPaneProps {
  productId: string
  location: any
  product: IProviderProductObject
}

const IProductStepPane = ({ productId, location, product }: IProductStepPaneProps) => {
  const ProductInfo = () => {
    return <ProductInfoPane product={product} />
  }

  const ProductIntegration = () => {
    return <ProductIntegrationPane product={product} />
  }

  const ProductPricing = () => {
    if (!product) {
      return null
    }
    return <ProductPricingPane pricing={product.pricing} />
  }

  const infoRedirect = () => <Redirect to={`/products/${productId}/info`} />

  return (
    <div className='mt1'>
      <ProductStepSelector pathname={location.pathname} productId={productId} />
      <div>
        <Switch>
          <Route path={`/products/${productId}/info`} render={ProductInfo} />
          <Route path={`/products/${productId}/pricing`} render={ProductPricing} />
          <Route path={`/products/${productId}/integration`} render={ProductIntegration} />
          <Route exact={true} path={`/products/${productId}`} component={infoRedirect} />
        </Switch>
      </div>
    </div>
  )
}

class ProductDetailPane extends React.Component<IProductDetailPaneProps> {
  public componentDidMount() {
    const { productId } = this.props
    this.props.fetchProduct(productId)
  }

  public render() {
    const { product } = this.props
    if (!product) {
      return null
    }

    const isActive = !product.deactivationDate ? true : false

    const deactivatedDate = product.deactivationDate
      ? moment(product.deactivationDate)
          .format('MMMM DD, YYYY HH:MM:SS')
          .toString()
      : 'N/A'

    return (
      <section>
        <BackToList link='/products' className='flex' />
        <div className='flex justify-between'>
          <div className='form-title-header no-border'>
            <div>
              <span className='h3 font-blue-grey'>{product.name}</span>
              <span className='ml2 h5'>
                {UIMessages.common.status}: {isActive ? UIMessages.common.active : UIMessages.common.inactive}
              </span>
            </div>
          </div>
          <div className='flex items-center mr2'>
            <Link to={this.redirectPath()}>
              <ButtonBlueWithIcon title={'Edit'}>
                <Edit className='icon--16x16' />
              </ButtonBlueWithIcon>
            </Link>
          </div>
        </div>
        <IProductStepPane {...this.props} />
      </section>
    )
  }

  private redirectPath = () => {
    const { location } = this.props
    const { productId } = this.props

    if (/\/info/.test(location.pathname)) {
      return `/products/${productId}/edit/info`
    } else if (/\/pricing/.test(location.pathname)) {
      return `/products/${productId}/edit/pricing`
    } else if (/\/integration/.test(location.pathname)) {
      return `/products/${productId}/edit/integration`
    }
    return location.pathname
  }
}

export default ProductDetailPane



// WEBPACK FOOTER //
// ./src/components/products/details/product/details/ProductPane.tsx